import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import _ from 'lodash';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class ConcreteHammerReportForm extends Form {
	state = {
		data: {
			testDate: new Date(),
			surfaceCondition: '',
			stageOfTest: '',
			index: '',
			hammerOrientation: '',
			equipment: '',
			serialNumber: '',
			calibrationDueDate: new Date(),
			angle: '',
			face: '',
			refStd: '',
			acceptanceStd: '',
			material: '',
			summary: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		testDate: Joi.date().less('now').required().label('Test Date'),
		surfaceCondition: Joi.string().min(3).required().label('Surface Condition'),
		stageOfTest: Joi.string().min(3).required().label('Stage of Test'),
		index: Joi.number().min(0).required().label('Index'),
		hammerOrientation: Joi.string().min(3).required().label('Hammer Orientation'),
		equipment: Joi.string().min(3).required().label('Equipment and Modal'),
		calibrationDueDate: Joi.date().greater('now').required().label('Calibration Due Date'),
		serialNumber: Joi.string().min(3).required().label('Serial Number'),
		angle: Joi.number().positive().required().label('Angle (deg)'),
		face: Joi.string().min(3).required().label('Face'),
		refStd: Joi.string().min(3).required().label('Ref Std'),
		acceptanceStd: Joi.string().min(3).required().label('Acceptance Std'),
		material: Joi.string().required().label('Material'),
		summary: Joi.string().min(3).required().label('Summary'),
	};

	static propTypes = {
		initialConcreteData: PropTypes.object,
		onProceed: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialConcreteData) {
			const initialData = { ...this.props.initialConcreteData };

			if (_.isString(initialData.testDate)) {
				initialData.testDate = new Date(initialData.testDate);
			}
			
			if (_.isString(initialData.calibrationDueDate)) {
				initialData.calibrationDueDate = new Date(initialData.calibrationDueDate);
			}

			this.setState({ data: initialData });
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data);
		toastService.success('Saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderDatePicker({
							name: 'testDate',
							label: 'Test Date',
							placeholderText: 'Select Test Date',
							maxDate: new Date(),
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'surfaceCondition',
							label: 'Surface Condition',
							placeholder: 'Enter Surface Condition',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'stageOfTest',
							label: 'Stage of Test',
							placeholder: 'Enter Stage of Test',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'index',
							label: 'Index',
							placeholder: 'Enter Index Value',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							options: [{ id: 'Vertical', name: 'Vertical' }, { id: 'Horizontal', name: 'Horizontal'}],
							name: 'hammerOrientation',
							label: 'Hammer Orientation',
							placeholder: 'Enter Hammer Orientation',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipment',
							label: 'Equipment and Modal',
							placeholder: 'Enter Equipment and Modal',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'serialNumber',
							label: 'Serial Number',
							placeholder: 'Enter Serial Number',
						})}
					</div>

					<div className="col">
						{this.renderDatePicker({
							name: 'calibrationDueDate',
							label: 'Calibration Due Date',
							placeholderText: 'Select Calibration Due Date',
							minDate: new Date(),
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'angle',
							label: 'Angle (deg)',
							placeholder: 'Enter Angle (deg)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'face',
							label: 'Face',
							placeholder: 'Enter Face',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'refStd',
							label: 'Ref Standard',
							placeholder: 'Enter Ref Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'acceptanceStd',
							label: 'Acceptance Standard',
							placeholder: 'Enter Acceptance Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'material',
							label: 'Material',
							placeholder: 'Enter Material',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				{this.renderTextArea({
					name: 'summary',
					placeholder: 'Enter Summary',
					label: 'Summary',
					rows: '6',
				})}

				{this.renderButton('Save Concrete Hammer Data')}
			</form>
		);
	}
}

export default ConcreteHammerReportForm;
